export const SET_SPECIFIC_QUERY_PARAMS_FULLY = 'SET_SPECIFIC_QUERY_PARAMS_FULLY'
export const SET_SPECIFIC_QUERY_PARAM = 'SET_SPECIFIC_QUERY_PARAM'
export const SET_EXPRESS_DELIVERY_SELECTED_STATE = 'SET_EXPRESS_DELIVERY_SELECTED_STATE'
